module.exports = __webpack_public_path__ + "img/lecteur-video.d718f868.png";